import { type Whatsapp1Card, type Whatsapp2Card, Whatsapp1CardSchema, Whatsapp2CardSchema } from "@stackje/common/config";
import { ValidationError } from "./validation";

export function parseWhatsapp1Card(formData: FormData): Whatsapp1Card {
  const cardData = {
    type: "whatsapp1" as const,
    colors: JSON.parse(formData.get("colors") as string),
    whatsappNumber: formData.get("whatsappNumber") as string,
    initialMessage: (formData.get("initialMessage") as string) || undefined,
    buttonText: (formData.get("buttonText") as string) || undefined,
    title: (formData.get("title") as string) || undefined,
    description: (formData.get("description") as string) || undefined,
  };

  try {
    return Whatsapp1CardSchema.parse(cardData);
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}

export function parseWhatsapp2Card(formData: FormData): Whatsapp2Card {
  const cardData = {
    type: "whatsapp2" as const,
    colors: JSON.parse(formData.get("colors") as string),
    whatsappNumber: formData.get("whatsappNumber") as string,
    initialMessage: (formData.get("initialMessage") as string) || undefined,
    buttonText: (formData.get("buttonText") as string) || undefined,
    title: (formData.get("title") as string) || undefined,
    description: (formData.get("description") as string) || undefined,
  };

  try {
    return Whatsapp2CardSchema.parse(cardData);
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}